import { EnumSiNoTodos, FilterSearchingBaseViewModel, PagingResultsViewModel } from '../../../../core/_infrastructure/types/common';

export class PeriodoCamItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: PeriodoCamItemViewModel[];
}

export class PeriodoCamItemViewModel {
    public Id: number;
    public FechaInicio: Date;
    public FechaFin: Date;
    public DescripcionCampania: string;
    public DescripcionPeriodo: string;
    public SuperficieMax: number | null;
    public Dextrio: number | null;
    public Parcela: boolean;
    public Confeccion: boolean;
    public Invernadero: boolean;
    public EmpresaDeshidratacion: boolean;
    public PresentarSolicitudesFueraPeriodo: boolean;
    public ControlProduccionExportacion: boolean;
    public HabilitadaTemporalmente: boolean;
    public CicloCortoInspParcela: boolean;
    public CicloCortoInspConfeccion: boolean;
    public CicloCortoInspInvernadero: boolean;
    public CicloCortoInspEmpresasDeshidratacion: boolean;
    public RequiereFirmaInspectorPaisDestino: boolean;
    public AvisoConfeccion: boolean;
    public RequiereAvisoFechaConfeccion: boolean;
    public TamanioMaximoAgrupacion: boolean;
    public AmbitoNacional: boolean;
    public EsVisibleEdicion: boolean;
}

export class FilterSearchingPeriodoCamViewModel extends FilterSearchingBaseViewModel {
    public FechaInicio: Date | null;
    public FechaFin: Date | null;
    public DescripcionPeriodo = '';
    public IdCampania: number | null;
    public Parcela: number = EnumSiNoTodos.TODOS;
    public Confeccion: number = EnumSiNoTodos.TODOS;
    public Invernadero: number = EnumSiNoTodos.TODOS;
    public EmpresaDeshidratacion: number = EnumSiNoTodos.TODOS;
    public EsUsuarioComunidadAutonoma: boolean;
    public IdUsuario: number;
}

export class PeriodoCamViewModel {
    constructor() {}

    public Id: number;
    public FechaInicio: Date;
    public FechaFin: Date;
    public IdCampania: number;
    public IdCampaniaDescripcion: string;
    public DescripcionPeriodo: string;
    public SuperficieMax: number | null;
    public Dextrio: number | null;
    public Parcela: boolean;
    public Confeccion: boolean;
    public Invernadero: boolean;
    public EmpresasDeshidratacion: boolean;
    public PresentarSolicitudesFueraPeriodo: boolean;
    public ControlProduccionExportacion: boolean;
    public HabilitadaTemporalmente: boolean;
    public CicloCortoInspParcela: boolean;
    public CicloCortoInspConfeccion: boolean;
    public CicloCortoInspInvernadero: boolean;
    public CicloCortoInspEmpresasDeshidratacion: boolean;
    public RequiereFirmaInspectorPaisDestino: boolean;
    public AvisoConfeccion: boolean;
    public RequiereAvisoFechaConfeccion: boolean;
    public TamanioMaximoAgrupacion: boolean;
    public AmbitoNacional: boolean;
    public PresentacionAutoEnabled: boolean;
    public CicloCortoEnabled: boolean; // En solicitudes de campaña usar el campo correspondiente al tipo de solicitud
    public CertificaKgs: boolean; // Obliga o no hacer cortes
    public TPeriodoTipoSolicitudCamCollection: PeriodoTipoSolicitudCamViewModel[];
}

export class PeriodoTipoSolicitudCamViewModel {
    public Id: number;
    public IdPeriodo: number;
    public IdTipoSolicitud: number;
}
